import { Button, Select, Input, Tooltip } from "antd";
import {
  DownloadIcon,
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../atoms/CustomIcons";
import { useState } from "react";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      search_text: string | undefined;
      state: string[] | undefined;
      city: string[] | undefined;
      crew: string[] | undefined;
    }>
  >;
  filters: {
    search_text: string | undefined;
    state: string[] | undefined;
    city: string[] | undefined;
    crew: string[] | undefined;
  };
  deactivated: boolean;
  isDeactivated: React.Dispatch<React.SetStateAction<boolean>>;
}

const states = [
  { label: "CA", value: "CA" },
  { label: "TX", value: "TX" },
  { label: "NY", value: "NY" },
  { label: "FL", value: "FL" },
  { label: "IL", value: "IL" },
  { label: "PA", value: "PA" },
];

const cities = [
  { label: "New York", value: "New York" },
  { label: "Los Angeles", value: "Los Angeles" },
  { label: "Chicago", value: "Chicago" },
  { label: "Houston", value: "Houston" },
  { label: "Phoenix", value: "Phoenix" },
  { label: "Philadelphia", value: "Philadelphia" },
  { label: "San Antonio", value: "San Antonio" },
  { label: "San Diego", value: "San Diego" },
  { label: "Dallas", value: "Dallas" },
  { label: "San Jose", value: "San Jose" },
];

export default function Filters(props: FilterProps) {
  const { setFilters, filters, isDeactivated, deactivated } = props;
  const [showFilters, setShowFilters] = useState(false);

  const clearFilters = () => {
    setFilters({
      search_text: undefined,
      state: undefined,
      city: undefined,
      crew: undefined,
    });
    isDeactivated(false);
  };
  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search"
            value={filters?.search_text}
            allowClear
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                search_text: e.target.value,
              }))
            }
          />
        </div>
        <div className="filterToggle">
          <Button
            icon={<FilterIcon />}
            className={`outlined-btn ${showFilters && "show_filters"} ${
              deactivated && "archived"
            }`}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters{" "}
            <div className="filter_icon">
              <SelectArrow />
            </div>
          </Button>
        </div>
        <div className="filterDownload">
          <Button icon={<DownloadIcon />} />
        </div>
      </div>
      {showFilters && (
        <div className="filtersBottom">
          <div className="btmLeft">
            <div className="filterBox">
              <Tooltip title="Crew" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "250px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  allowClear
                  showSearch
                  placeholder="Crew"
                  options={[]}
                  value={filters?.crew}
                  onChange={(value) =>
                    setFilters((prev) => ({
                      ...prev,
                      position: value,
                    }))
                  }
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <Tooltip title="State" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "250px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  allowClear
                  showSearch
                  placeholder="State"
                  options={states}
                  value={filters?.state}
                  onChange={(value) =>
                    setFilters((prev) => ({
                      ...prev,
                      state: value,
                    }))
                  }
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <Tooltip title="City" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "250px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  allowClear
                  showSearch
                  placeholder="City"
                  options={cities}
                  value={filters?.city}
                  onChange={(value) =>
                    setFilters((prev) => ({
                      ...prev,
                      city: value,
                    }))
                  }
                />
              </Tooltip>
            </div>
          </div>

          <div className="btmRight">
            <Button
              className="outlined-btn"
              onClick={clearFilters}
              disabled={
                !filters?.search_text &&
                !filters?.state &&
                !filters?.city &&
                !deactivated
                  ? true
                  : false
              }
            >
              Clear filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
